const IMPERSONATOR_TOKEN_KEY = 'hrm_impersonator_token';
const IMPERSONATOR_USER_KEY = 'hrm_impersonator_user';
const IMPERSONATION_META_KEY = 'hrm_impersonation_meta';

export type ImpersonationMeta = {
    type?: 'employee' | 'tenant';
    employee_id?: number;
    employee_name?: string;
    tenant_owner_id?: number;
    tenant_owner_name?: string;
    return_path?: string;
    impersonator?: { id: number; name: string; email: string } | null;
};

export function isImpersonating(): boolean {
    return Boolean(sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY));
}

export function getImpersonationMeta(): ImpersonationMeta | null {
    try {
        const raw = sessionStorage.getItem(IMPERSONATION_META_KEY);
        return raw ? (JSON.parse(raw) as ImpersonationMeta) : null;
    } catch {
        return null;
    }
}

export function saveImpersonatorSession(token: string | null, user: unknown, meta: ImpersonationMeta): void {
    if (token) {
        sessionStorage.setItem(IMPERSONATOR_TOKEN_KEY, token);
    }
    if (user) {
        sessionStorage.setItem(IMPERSONATOR_USER_KEY, JSON.stringify(user));
    }
    sessionStorage.setItem(IMPERSONATION_META_KEY, JSON.stringify(meta));
}

export function clearImpersonatorSession(): void {
    sessionStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
    sessionStorage.removeItem(IMPERSONATOR_USER_KEY);
    sessionStorage.removeItem(IMPERSONATION_META_KEY);
}

export function restoreImpersonatorSession(): { token: string | null; user: unknown | null } {
    const token = sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY);
    let user: unknown | null = null;
    try {
        const raw = sessionStorage.getItem(IMPERSONATOR_USER_KEY);
        user = raw ? JSON.parse(raw) : null;
    } catch {
        user = null;
    }
    clearImpersonatorSession();
    return { token, user };
}
